import Heading from '../../../../components/Heading/Heading';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import CONSTANTS from '../../../../constants';
import styles from '../../css/User.module.css';
import { useEffect, useState } from 'react';
import {
	generateApprovedUserDetails,
	generateApprovedUsers,
	removeApprovedUser,
} from '../../../../utils/common.utils';
import {
	getMonthFormatDate,
	getTimestamp,
} from '../../../../utils/getDate.utils';
import Icon from '../../../../components/Icon/Icon';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Tooltip } from 'primereact/tooltip';
import ViewUserData from './ViewUserData';
import CreateUser from '../Create User/CreateUser';

const ListUsers = () => {
	const [approvedUsers, setApprovedUsers] = useState([]);
	const [userDetails, setUserDetails] = useState({});

	useEffect(() => {
		generateApprovedUsers(setApprovedUsers);
	}, []);

	// console.log(approvedUsers);

	//Active Approved Users
	const activeApprovedUsers = approvedUsers.filter(
		(userObj) => userObj.active === 'Y'
	);

	const handleDeleteUser = (rowData) => {
		removeApprovedUser(rowData.userId);
	};

	const handleGetUserDetails = (rowData) => {
		generateApprovedUserDetails(
			rowData.userId,
			setUserDetails,
			approvedUsers,
			setApprovedUsers
		);
	};

	const handleEditApprovedUser = (rowData) => {
		//Get user role obj and change edit visibility
		const newUserList = approvedUsers.map((obj) => {
			if (obj.userName === rowData.userName) {
				const newUserObj = { ...obj, visibleEditable: true };
				return newUserObj;
			}
			return obj;
		});
		// console.log(newUserList);
		//Set new user role list to re-render the rowData
		setApprovedUsers(newUserList);
	};

	// console.log(userDetails);

	const creationDateTemplate = (field) => {
		const convertedTimestamp = getTimestamp(field.creationDate);
		const date = getMonthFormatDate(convertedTimestamp?.split(' ')[0]);
		const time = convertedTimestamp?.split(' ')[1];
		const ampm = convertedTimestamp?.split(' ')[2];
		return <span>{`${date} ${time} ${ampm}`}</span>;
	};

	const actionBodyTemplate = (rowData) => {
		// console.log(rowData);
		const roleName = rowData.userRole;
		const isEditAllowed = !(roleName === 'admin' || roleName === 'channel');
		return (
			<div className={styles['actions__container']}>
				{isEditAllowed && (
					<Icon
						icon="edit"
						tooltip="Create an edit request"
						className={`${styles['actions-icon']} ${styles['table-icon']} edit`}
						onClick={() => handleEditApprovedUser(rowData)}
					/>
				)}
				<Tooltip target=".edit" position="top" className={styles.tooltip} />
				<Dialog
					header="Edit user details"
					visible={rowData.visibleEditable}
					maximizable
					onHide={() => {
						//Get user obj and change visibility
						const newUserList = approvedUsers.map((obj) => {
							if (obj.userName === rowData.userName) {
								const newUserObj = { ...obj, visibleEditable: false };
								return newUserObj;
							}
							return obj;
						});
						// console.log(newUserList);
						//Set new user role list to re-render the rowData
						setApprovedUsers(newUserList);
					}}
				>
					<CreateUser isEditable userId={rowData.userId} />
				</Dialog>
				{isEditAllowed && (
					<Icon
						icon="delete"
						tooltip="Create a delete request"
						className={`${styles['actions-icon']} ${styles['table-icon']} delete`}
						onClick={() => handleDeleteUser(rowData)}
					/>
				)}
				<Tooltip target=".delete" position="top" className={styles.tooltip} />
				<Button
					className={styles['action-button']}
					onClick={() => handleGetUserDetails(rowData)}
				>
					View Details
				</Button>
				<Dialog
					header="User Details"
					visible={rowData.visible}
					onHide={() => {
						//Change one single object
						const updatedUserDetails = { ...userDetails, visible: false };
						setUserDetails(updatedUserDetails);
						//Change array of objects to maintain state
						const updatedApprovedUserList = approvedUsers.map((userObj) =>
							userObj.userId === rowData.userId ? updatedUserDetails : userObj
						);
						setApprovedUsers(updatedApprovedUserList);
					}}
				>
					<ViewUserData userData={userDetails} />
				</Dialog>
			</div>
		);
	};

	return (
		<div className="main">
			<Heading>List of approved users</Heading>
			<div className={styles['user__container']}>
				<div className={styles['table__container']}>
					<DataTable
						value={activeApprovedUsers}
						paginator
						rows={20}
						rowsPerPageOptions={[5, 10, 15, 20, 30, 50]}
						emptyMessage="No approved users found."
						removableSort
					>
						{CONSTANTS.userColumns.map((column) => (
							<Column
								key={column.field}
								field={column.field}
								header={column.header}
								sortable
								className={styles['wrap-text']}
							/>
						))}
						<Column
							body={creationDateTemplate}
							field="creationDate"
							header="Creation Date"
							sortable
						></Column>
						<Column
							body={actionBodyTemplate}
							field="actions"
							header="User Actions"
						></Column>
					</DataTable>
				</div>
			</div>
		</div>
	);
};

export default ListUsers;
